//////// GHG 3.8 EF
const threeEightSchema = {
  title: "3.8 Upstream Leased Assets",
  cat: "4_4",
  catName: "cat4",
  progressiveOrderSwitch: {
    by: { level: 2, key: "assetType4_4" },
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    //////// Data Source
    {
      key: "emissionFactorTypeId",
      level: 1,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
    },
    //////// Asset Type
    {
      key: "assetType4_4",
      level: 2,
      type: "select",
      label: "Asset Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        value: "4_4",
      },
      showIf: {
        all: [
          { level: 1, key: "emissionFactorTypeId", ne: "2" },
          { level: 1, key: "emissionFactorTypeId", notEmpty: true },
        ],
      },
      combineKey: 1,
    },
    //////////////// AssetType第一種可能
    //////// Emission Factor Database Source
    {
      key: "sourceEFName4_4",
      level: 5,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "assetType4_4",
      },
      showIf: {
        level: 2,
        key: "assetType4_4",
        eq: "Mobile Gen-Set",
      },
      combineKey: 2,
    },
    //////// Fuel Type
    {
      key: "fuelTypeOrVehicleCategory4_4",
      level: 6,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "sourceEFName4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Mobile Gen-Set" },
          {
            level: 5,
            key: "sourceEFName4_4",
            notEmpty: true,
          },
        ],
      },
      combineKey: 3,
    },
    //////// Fuel Name
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelTypeOrVehicleCategory4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Mobile Gen-Set" },
          {
            level: 6,
            key: "fuelTypeOrVehicleCategory4_4",
            notEmpty: true,
          },
        ],
      },
      combineKey: 4,
    },
    //////////////// AssetType第二種可能 Computational Method第一種可能
    //////// Computational Method
    {
      key: "computationMethodOrEnergySource4_4",
      level: 3,
      type: "select",
      label: "Computational Method",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "assetType4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", notEmpty: true },
          { level: 2, key: "assetType4_4", eq: "Transport" },
        ],
      },
      combineKey: 2,
    },
    //////// Emission Factor Database Source
    {
      key: "sourceEFName4_4",
      level: 5,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "computationMethodOrEnergySource4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Transport" },
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Fuel Based",
          },
        ],
      },
      combineKey: 3,
    },
    //////// Fuel Type
    {
      key: "fuelTypeOrVehicleCategory4_4",
      level: 6,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "sourceEFName4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Transport" },
          {
            level: 5,
            key: "sourceEFName4_4",
            notEmpty: true,
          },
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Fuel Based",
          },
        ],
      },
      combineKey: 4,
    },
    //////// Fuel Name
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelTypeOrVehicleCategory4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Transport" },
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Fuel Based",
          },
          {
            level: 6,
            key: "fuelTypeOrVehicleCategory4_4",
            notEmpty: true,
          },
        ],
      },
      combineKey: 5,
    },
    //////////////// AssetType第二種可能 Computational Method第二種可能
    //////// Transport Model
    {
      key: "transportModel4_4",
      level: 4,
      type: "select",
      label: "Transport Model",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "computationMethodOrEnergySource4_4",
      },
      showIf: {
        all: [
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Distance Based",
          },
        ],
      },
      combineKey: 3,
    },
    //////// Emission Factor Database Source
    {
      key: "sourceEFName4_4",
      level: 5,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "transportModel4_4",
      },
      showIf: {
        all: [
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Distance Based",
          },
          {
            level: 4,
            key: "transportModel4_4",
            notEmpty: true,
          },
        ],
      },
      combineKey: 4,
    },
    //////// Vehicle Type
    {
      key: "fuelTypeOrVehicleCategory4_4",
      level: 6,
      type: "select",
      label: "Vehicle Category",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "sourceEFName4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Transport" },
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Distance Based",
          },
          { level: 5, key: "sourceEFName4_4", notEmpty: true },
        ],
      },
      combineKey: 5,
    },
    //////// Fuel Name
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Vehicle Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelTypeOrVehicleCategory4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Transport" },
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Distance Based",
          },
          {
            level: 6,
            key: "fuelTypeOrVehicleCategory4_4",
            notEmpty: true,
          },
        ],
      },
      combineKey: 6,
    },
    //////////////// AssetType第三種可能 Energy Source第一種可能
    //////// Computational Method
    {
      key: "computationMethodOrEnergySource4_4",
      level: 3,
      type: "select",
      label: "Energy Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "assetType4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", notEmpty: true },
          { level: 2, key: "assetType4_4", eq: "Others" },
        ],
      },
      combineKey: 2,
    },
    //////// Emission Factor Database Source
    {
      key: "sourceEFName4_4",
      level: 5,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "computationMethodOrEnergySource4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Others" },
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Fuel",
          },
        ],
      },
      combineKey: 3,
    },
    //////// Fuel Type
    {
      key: "fuelTypeOrVehicleCategory4_4",
      level: 6,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "sourceEFName4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Others" },
          {
            level: 5,
            key: "sourceEFName4_4",
            notEmpty: true,
          },
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Fuel",
          },
        ],
      },
      combineKey: 4,
    },
    //////// Fuel Name
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelTypeOrVehicleCategory4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Others" },
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Fuel",
          },
          {
            level: 6,
            key: "fuelTypeOrVehicleCategory4_4",
            notEmpty: true,
          },
        ],
      },
      combineKey: 5,
    },
    ////////////////AssetType第三種可能 Energy Source第二種可能
    //////// Emission Factor Database Source
    {
      key: "sourceEFName4_4",
      level: 5,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "computationMethodOrEnergySource4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Others" },
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Purchased Electricity",
          },
        ],
      },
      combineKey: 3,
    },
    //////// Location ( Country )
    {
      key: "location4_4",
      level: 6,
      type: "select",
      label: "Location ( Country )",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "sourceEFName4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Others" },
          {
            level: 5,
            key: "sourceEFName4_4",
            notEmpty: true,
          },
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Purchased Electricity",
          },
        ],
      },
      combineKey: 4,
    },
    //////// State / City
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "State / City",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "location4_4",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Others" },
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Purchased Electricity",
          },
          {
            level: 6,
            key: "location4_4",
            notEmpty: true,
          },
        ],
      },
      combineKey: 5,
    },
    ////////////////AssetType第三種可能 Energy Source第三種可能
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 7,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat4CustomEFDropdownList",
      showIf: {
        all: [
          { level: 2, key: "assetType4_4", eq: "Others" },
          {
            level: 3,
            key: "computationMethodOrEnergySource4_4",
            eq: "Renewable Energy",
          },
        ],
      },
      autoFillNum: 0,
    },
    ////////////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 7,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat4CustomEFDropdownList",
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
  ],
};

export default threeEightSchema;
